import { DateTime } from 'luxon';

import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';

import * as Yup from 'yup';

import ItemList from './Components/ItemList';
import ItemListHeader from './Components/ItemListHeader';


const headers = [
  {
    label: 'Consignment Id',
    id: 'consignment_id'
  },
  {
    label: 'Vendor',
    id: 'vendor'
  },
  {
    label: 'Total Qty',
    id: 'total_qty'
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "accepted", status: "success"}, {value: "shipped", status: "secondary"}, {value: "pending", status: "primary"}, {value: "partial", status: "warning"}]
  },
  {
    label: "Type",
    id: "shipment_type",
    multi: true,
    values: [{value: "inbound", label: "Consignment", status: "success"}, {value: "outbound", label: "Return", status: "warning"}]
  },
  {
    label: 'Date',
    date: true,
    id: 'date_created'
  }
];

const filters = [
  {
    id: "date_created",
    type: "date",
    label: "Date Created",
  }
]

const fields = [
  {
    fieldType: "Component",
    Component: <ItemListHeader />,
    name: "item_list_header",
    size: {xs: 12, md: 12}
  },
  {
    fieldType: "divider",
    header: "Shipment Items",
    name: "shipment_items",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <ItemList />,
    name: "item_list",
    size: {xs: 12, md: 12}
  }
]

const initialValues = {
  vendor_id: '',
  date_created: DateTime.local(),
}

const additionalState = {
  items: [
    // { wig_id: 'W-1042', sku: 'EU-HH-18-NB',  cost: 420.00, price: 899.00 },
    // { wig_id: 'W-1043', sku: 'EU-HH-20-NB',  cost: 460.00, price: 949.00 },
    // { wig_id: 'W-1051', sku: 'BR-LC-16-DB',  cost: 285.00, price: 649.00 },
    // { wig_id: 'W-1058', sku: 'SY-FL-22-HL',  cost: 95.00,  price: 229.00 },
    // { wig_id: 'W-1063', sku: 'EU-MN-14-OM',  cost: 510.00, price: 1099.00 },
    // { wig_id: 'W-1071', sku: 'BR-FT-24-BK',  cost: 340.00, price: 749.00 },
  ],
  vendor_name: '',
  vendor_wigs: []
}

const tabs = [
  {id: "all", label: "All", Icon: AllInclusiveRoundedIcon },
  {id: "inbound", label: "Consignments", Icon: Inventory2RoundedIcon },
  {id: "outbound", label: "Returns", Icon: LocalShippingRoundedIcon },
]

const schema = Yup.object().shape({
  
});

const parseData = (data) => {
  const parsed = {
    ...data,
  };
  parsed.date_created = DateTime.fromISO(data.date_created);
  parsed.vendor_id = data.vendor_id?.toString();
  return parsed
}

export {filters, headers, fields, initialValues, tabs, schema, additionalState, parseData };
